import * as React from "react";
import { FormControl, FormLabel, Input, Typography } from "@mui/joy";
import { Controller, useFormContext } from "react-hook-form";

interface FormInputProps {
    name: string;
    label?: string;
    helperText?: string;
    startDecorator?: React.ReactNode;
    [key: string]: any;
}

export default function FormInput({
    name,
    label,
    helperText,
    startDecorator,
    ...props
}: FormInputProps) {
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState }) => (
                <FormControl
                    size="md"
                    error={!!fieldState.error}
                    sx={{ flex: 1, width: "100%" }}
                >
                    {label && (
                        <FormLabel
                            sx={{
                                textTransform: "uppercase",
                                fontSize: "12px",
                                fontWeight: "xl",
                                letterSpacing: "0.5px",
                            }}
                        >
                            {label}
                        </FormLabel>
                    )}
                    {helperText && (
                        <Typography
                            level="body-xs"
                            color="neutral"
                            sx={{ mt: -0.5, mb: 0.5, fontSize: "12px" }}
                        >
                            {helperText}
                        </Typography>
                    )}
                    <Input
                        {...field}
                        startDecorator={startDecorator}
                        {...props}
                        sx={{
                            bgcolor: "background.surface",
                            borderRadius: "4px",
                            boxShadow: "none",
                            ...props.sx,
                        }}
                    />
                    {fieldState.error && (
                        <Typography
                            level="body-xs"
                            color="danger"
                            sx={{ mt: 0.5 }}
                        >
                            {fieldState.error.message}
                        </Typography>
                    )}
                </FormControl>
            )}
        />
    );
}
